import {useEffect,useState,useContext} from 'react'
import './projectsEntry.css'
import {ReactComponent as GipLogoSvg} from '../../img/gipLogoSvg.svg'
import {ReactComponent as SimplixLogoSvg} from '../../img/simplixLogoSvg.svg'
import {useParams} from 'react-router-dom';
import { Oval } from  'react-loader-spinner'

export default function ProjectsEntry(props){
    const [key, setKey] = useState('')
    const params = useParams();
    // props?.data?.insertKeyFunction
    //ii8pES+6bFS3bwCrl428zHKJFPKORSJVz1UhIj3f6t0=
    
    useEffect(() => {
        if(params.key != undefined){
            props?.data?.insertKeyFunction(params.key)
        }
    }, [])

    return (
        <div className='containerGlobalOrderPriceEntry'>
            <div className='containerElementsOrderPriceEntry'>
                {props?.data?.loadingKeyState?
                    <div className='containerLoadingKeyOrderPriceEntry'>
                        <Oval
                            height={'5.6rem'}
                            width={'5.6rem'}
                            color="#028446"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#4fa94d"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                        />
                    </div>
                    :
                    <div className='containerLogosOrderPriceEntry'>
                        <GipLogoSvg className="gipLogoOrderPriceEntry" style={{}}/>
                        <SimplixLogoSvg className="simplixLogoOrderPriceEntry" style={{}}/>
                    </div>
                }
                <div className='divisionOrderPriceEntry'></div>
                <div className='containerInputKeyOrderPriceEntry' style={{opacity: props?.data?.loadingKeyState? "0.5" : "1"}}>
                    <div className="keyDisclaimerOrderPriceEntry">Insira a chave recebida</div>
                    <input type="text" className="orderPriceEntryInput" disabled={props?.data?.loadingKeyState? true : false} onChange={(e) => {
                        setKey(e.target.value)
                    }}/>
                    <button className={props?.data?.loadingKeyState? "orderPriceEntryButtonDisabled" : "orderPriceEntryButton"} disabled={props?.data?.loadingKeyState? true : false} onClick={() => {props?.data?.insertKeyFunction(key)}}>Entrar</button>
                    <div className='disclaimerEmailKey'></div>
                </div>
            </div>
            {/* <button onClick={() => {console.log(key)}}>CHAVE TESTE</button> */}
        </div>
    )
}